module.exports = __webpack_public_path__ + "static/media/promo-306.a28fc684.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-306.jpg
// module id = 308
// module chunks = 0